import { render, staticRenderFns } from "./RecruitTagAddLayer.vue?vue&type=template&id=3883520a&scoped=true&"
import script from "./RecruitTagAddLayer.vue?vue&type=script&lang=js&"
export * from "./RecruitTagAddLayer.vue?vue&type=script&lang=js&"
import style0 from "./RecruitTagAddLayer.vue?vue&type=style&index=0&id=3883520a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3883520a",
  null
  
)

export default component.exports